var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFinances = function SvgFinances(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.172 3c-.06.002-.118.008-.177.016h-5.317a1.658 1.658 0 1 0 0 3.315h1.524l-5.945 5.945-5.46-5.459a1.658 1.658 0 0 0-2.343 0l-6.632 6.631a1.659 1.659 0 1 0 2.345 2.345l5.459-5.46 5.459 5.46a1.658 1.658 0 0 0 2.344 0l7.117-7.117V10.2a1.659 1.659 0 1 0 3.316 0V4.866A1.66 1.66 0 0 0 37.172 3ZM3.5 22.359c0-2.117 1.752-3.869 3.868-3.869h34.263c2.116 0 3.868 1.752 3.868 3.869v18.789c0 2.116-1.752 3.868-3.869 3.868H7.368c-2.116 0-3.868-1.752-3.868-3.868v-18.79Zm35.367-.553H10.131a3.311 3.311 0 0 1-3.315 3.316v13.262A3.311 3.311 0 0 1 10.13 41.7h28.736a3.311 3.311 0 0 1 3.316-3.316V25.121a3.311 3.311 0 0 1-3.316-3.316Zm-20.999 9.947c0-4.266 2.974-7.737 6.631-7.737 3.658 0 6.632 3.47 6.632 7.737 0 4.266-2.974 7.737-6.632 7.737-3.657 0-6.631-3.47-6.631-7.737ZM9.674 30.19a2.21 2.21 0 1 1 3.126 3.126 2.21 2.21 0 0 1-3.126-3.126Zm26.525 0a2.21 2.21 0 1 1 3.126 3.126A2.21 2.21 0 0 1 36.2 30.19Z",
    fill: "#282828"
  })));
};

export default SvgFinances;